import { render, staticRenderFns } from "./PlayerLoader.vue?vue&type=template&id=f6e72a8c&scoped=true"
import script from "./PlayerLoader.vue?vue&type=script&lang=ts"
export * from "./PlayerLoader.vue?vue&type=script&lang=ts"
import style0 from "./PlayerLoader.vue?vue&type=style&index=0&id=f6e72a8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6e72a8c",
  null
  
)

export default component.exports